<h1
  class={`text-2xl sm:text-4xl font-extrabold tracking-tight text-primary-500 ${
    $$props.class ?? ''
  }`}
>
  <slot />
</h1>
